import {NgModule} from '@angular/core';
import {AjaxDownloadNotyComponent} from './ajax-download-noty.component';
import {AjaxDownloadService} from './ajax-download.service';
import { GenerationNotificationComponent } from './generation-notification/generation-notification.component';
import {SharedModule} from '@helpers/modules/shared.module';
import {PipesModule} from '@pipes/pipes.module';
import {IconsModule} from '@lab365/icons';


@NgModule({
    imports: [
        SharedModule,
        PipesModule,
        IconsModule,
    ],
    exports: [
        AjaxDownloadNotyComponent,
    ],
    declarations: [
        AjaxDownloadNotyComponent,
        GenerationNotificationComponent,
    ],
    providers: [
        AjaxDownloadService,
    ],
    entryComponents: [
        GenerationNotificationComponent,
    ]
})
export class AjaxDownloadNotyModule {
}
